/* GLAMRDiP Included-in-set contents rail — shared behaviour (Joel 2026-07-21).
   Extracted verbatim from the kit-hero gd-igkit-contents component: desktop drag-to-scroll
   (5px click-vs-drag threshold, no preventDefault on pointerdown per CLAUDE.md), tab jump,
   and the ARIA scrubber (click-jump + fill-drag + keyboard). Idempotent (gdKcInit guard).
   Used by both IG rails via [data-gd-igkit-contents]. Canonical — ports to CA/UK/Nordics. */
(function(){
  function initGdIgContents(){
      document.querySelectorAll('[data-gd-igkit-contents]').forEach((root) => {
    if (root.dataset.gdKcInit === '1') return;
    root.dataset.gdKcInit = '1';
    const tabs     = root.querySelectorAll('[data-gd-igkit-tab]');
    const track    = root.querySelector('[data-gd-igkit-track]');
    const progress = root.querySelector('[data-gd-igkit-progress]');
    const fill     = root.querySelector('[data-gd-igkit-progress-fill]');
    if (!track) return;

    // Joel 2026-04-29: desktop drag-to-scroll on the card row. Mouse
    // pointer only — touch keeps the native swipe path so iOS momentum
    // scroll isn't replaced with a worse JS approximation. Click-vs-
    // drag disambig via 5px threshold so card-internal click targets
    // (i info icons, future variants) still register as clicks.
    let cardDrag = null;
    const CARD_DRAG_THRESHOLD = 5;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      // Joel 2026-05-03 (CLAUDE.md "Native image drag" rule, recurring
      // bug class): the prior comment justified preventDefault here as
      // OS-level image-drag suppression. That justification is wrong —
      // preventDefault on pointerdown ALSO suppresses the synthesized
      // click event on desktop (mouse pointer) — every clickable card
      // in the gallery becomes unclickable. The dragstart handler at
      // line 719 below + the global CSS rule (img { user-drag: none })
      // in glamrdip-tokens.css.liquid already kill OS-level image-drag
      // without breaking clicks. The wasMoved click-swallow at
      // pointerup is the correct mechanism for click-vs-drag
      // disambiguation. Same bug appears 2026-05-03 on salon-kit-
      // nail-art-reels (Joel's report: "reels on desktop wont open")
      // — applied identical fix there. Removing preventDefault here
      // pre-emptively to prevent the same user-visible bug on the
      // kit-hero gallery.
      cardDrag = {
        pointerId: e.pointerId,
        startX: e.clientX,
        startScrollLeft: track.scrollLeft,
        latestX: e.clientX,
        moved: false,
        rafQueued: false,
      };
      try { track.setPointerCapture(e.pointerId); } catch {}
    });
    // Belt-and-braces: any descendant image that the user click-drags
    // on dispatches `dragstart` before pointerdown can preventDefault
    // (the order varies by browser). Cancelling dragstart at the track
    // level catches every img + a (links) in one place.
    track.addEventListener('dragstart', (e) => { e.preventDefault(); });
    track.addEventListener('pointermove', (e) => {
      if (!cardDrag || cardDrag.pointerId !== e.pointerId) return;
      cardDrag.latestX = e.clientX;
      const dx = cardDrag.latestX - cardDrag.startX;
      if (Math.abs(dx) > CARD_DRAG_THRESHOLD) cardDrag.moved = true;
      if (!cardDrag.moved) return;
      e.preventDefault();
      track.classList.add('is-dragging');
      if (cardDrag.rafQueued) return;
      cardDrag.rafQueued = true;
      window.requestAnimationFrame(() => {
        if (!cardDrag) return;
        cardDrag.rafQueued = false;
        track.scrollLeft = cardDrag.startScrollLeft - (cardDrag.latestX - cardDrag.startX);
      });
    });
    function endCardDrag(e) {
      if (!cardDrag || cardDrag.pointerId !== e.pointerId) return;
      const wasMoved = cardDrag.moved;
      try { track.releasePointerCapture(cardDrag.pointerId); } catch {}
      track.classList.remove('is-dragging');
      cardDrag = null;
      // Swallow the click that follows pointerup-after-drag so accidental
      // clicks on the card content don't fire (info-icon etc.). One-shot
      // capture-phase click suppressor that removes itself.
      if (wasMoved) {
        const swallow = (ev) => {
          ev.stopPropagation();
          ev.preventDefault();
          track.removeEventListener('click', swallow, true);
        };
        track.addEventListener('click', swallow, true);
        // Clear the listener if no click event fires within a frame
        // (e.g. pointerup outside any clickable child).
        setTimeout(() => track.removeEventListener('click', swallow, true), 0);
      }
    }
    track.addEventListener('pointerup', endCardDrag);
    track.addEventListener('pointercancel', endCardDrag);
    track.addEventListener('lostpointercapture', endCardDrag);

    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
      // dataset key must match the tab's data-gd-igkit-tab attribute (gdIgkitTab).
      // The Salon-Kit source reads gdKitTab for its data-gd-kit-tab attr; the
      // gd-kit-→gd-igkit- namespace rename was missed on this one line, leaving
      // cat undefined so the category lookup below never matched (Joel 2026-07-22).
      const cat = tab.dataset.gdIgkitTab;
      const target = track.querySelector(`[data-gd-igkit-category="${cat}"]`);
      if (target) track.scrollTo({ left: target.offsetLeft - 4, behavior: 'smooth' });
      // Tab swap changes the visible-card subset → progress fill width
      // (which is proportional to clientWidth/scrollWidth) needs to
      // recompute. scrollTo above fires the scroll listener; this is
      // belt-and-braces in case the target equals current scrollLeft.
      window.requestAnimationFrame(updateProgress);
    }));

    function updateProgress() {
      if (!progress || !fill) return;
      const overflow = track.scrollWidth - track.clientWidth;
      if (overflow <= 4) {
        progress.hidden = true;
        return;
      }
      progress.hidden = false;
      const visiblePct = Math.max(8, (track.clientWidth / track.scrollWidth) * 100);
      const scrollPct  = Math.max(0, Math.min(1, track.scrollLeft / overflow));
      const leftPct    = scrollPct * (100 - visiblePct);
      fill.style.width = visiblePct.toFixed(2) + '%';
      fill.style.left  = leftPct.toFixed(2) + '%';
      progress.setAttribute('aria-valuenow', Math.round(scrollPct * 100).toString());
    }

    // Joel 2026-04-29 (e): scrubber with two pointer paths.
    // PROGRESS gets pointerdown/up: tap = click-jump (no drag, just
    // scrollTo with smooth). FILL gets its own pointerdown/move/up:
    // capture on the fill itself, dx-scaled scroll. Splitting paths
    // because setPointerCapture on a different element from where
    // pointerdown originated isn't honoured uniformly across engines.
    let drag = null;
    const DRAG_THRESHOLD = 3;
    function clickJump(clientX) {
      const overflow = track.scrollWidth - track.clientWidth;
      if (overflow <= 4) return;
      const rect = progress.getBoundingClientRect();
      const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      track.scrollTo({ left: ratio * overflow, behavior: 'smooth' });
    }
    function startFillDrag(e) {
      const overflow = track.scrollWidth - track.clientWidth;
      if (overflow <= 4) return;
      const rect = progress.getBoundingClientRect();
      const fillRect = fill.getBoundingClientRect();
      drag = {
        pointerId: e.pointerId,
        anchorX: e.clientX,
        startScrollLeft: track.scrollLeft,
        usableW: Math.max(0.0001, rect.width - fillRect.width),
        overflow,
        latestX: e.clientX,
        rafQueued: false,
        moved: false,
      };
      try { fill.setPointerCapture(e.pointerId); } catch {}
      document.body.style.userSelect = 'none';
    }
    function moveFillDrag(e) {
      if (!drag || drag.pointerId !== e.pointerId) return;
      drag.latestX = e.clientX;
      if (Math.abs(drag.latestX - drag.anchorX) > DRAG_THRESHOLD) drag.moved = true;
      if (drag.rafQueued) return;
      drag.rafQueued = true;
      window.requestAnimationFrame(() => {
        if (!drag) return;
        drag.rafQueued = false;
        const dx = drag.latestX - drag.anchorX;
        const ratio = dx / drag.usableW;
        const newScroll = drag.startScrollLeft + ratio * drag.overflow;
        track.scrollLeft = Math.max(0, Math.min(drag.overflow, newScroll));
      });
    }
    function endFillDrag(e) {
      if (!drag || drag.pointerId !== e.pointerId) return;
      try { fill.releasePointerCapture(drag.pointerId); } catch {}
      document.body.style.userSelect = '';
      drag = null;
    }

    if (fill) {
      fill.addEventListener('pointerdown', (e) => {
        if (e.button !== undefined && e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        startFillDrag(e);
      });
      fill.addEventListener('pointermove', moveFillDrag);
      fill.addEventListener('pointerup', endFillDrag);
      fill.addEventListener('pointercancel', endFillDrag);
      fill.addEventListener('lostpointercapture', endFillDrag);
    }

    if (progress) {
      // pointerup-then-click model rather than the native click event:
      // pointerdown sets a flag, pointerup checks it + dispatches the
      // jump if the pointerdown originated outside of the fill (where
      // a fill-drag would have intercepted it via stopPropagation).
      let pointerDownX = null;
      progress.addEventListener('pointerdown', (e) => {
        if (e.button !== undefined && e.button !== 0) return;
        if (fill && (e.target === fill || fill.contains(e.target))) return;
        pointerDownX = e.clientX;
      });
      progress.addEventListener('pointerup', (e) => {
        if (pointerDownX === null) return;
        const dx = Math.abs(e.clientX - pointerDownX);
        pointerDownX = null;
        if (dx <= DRAG_THRESHOLD) clickJump(e.clientX);
      });
      // Keyboard nav (ARIA scrollbar contract).
      progress.addEventListener('keydown', (e) => {
        const overflow = track.scrollWidth - track.clientWidth;
        if (overflow <= 4) return;
        const step = track.clientWidth * 0.3;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp')         { e.preventDefault(); track.scrollBy({ left: -step, behavior: 'smooth' }); }
        else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); track.scrollBy({ left:  step, behavior: 'smooth' }); }
        else if (e.key === 'Home') { e.preventDefault(); track.scrollTo({ left: 0, behavior: 'smooth' }); }
        else if (e.key === 'End')  { e.preventDefault(); track.scrollTo({ left: overflow, behavior: 'smooth' }); }
      });
    }

    // Carousel scroll → recompute fill.
    track.addEventListener('scroll', () => window.requestAnimationFrame(updateProgress), { passive: true });
    window.addEventListener('resize', updateProgress);
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => updateProgress());
      ro.observe(track);
    }
    updateProgress();
    window.requestAnimationFrame(updateProgress);
    setTimeout(updateProgress, 400);
  });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGdIgContents);
  else initGdIgContents();
  document.addEventListener('shopify:section:load', initGdIgContents);
})();
